import enTranslations from '../locales/en_GB.json'
import frTranslations from '../locales/fr_FR.json'
import deTranslations from '../locales/de_DE.json'
import nlTranslations from '../locales/nl_NL.json'

const translations = {
  en_GB: enTranslations,
  fr_FR: frTranslations,
  de_DE: deTranslations,
  nl_NL: nlTranslations
}

// Create a reactive object to hold the current locale
export const i18n = {
  currentLocale: 'en_GB',
  translations,

  setLocale(locale) {
    this.currentLocale = locale
    // Trigger a custom event to notify components
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('locale-changed', { detail: locale }))
    }
  },

  $t(key) {
    const translation = this.translations[this.currentLocale]

    // Try to find the key in translations
    if (translation && Object.prototype.hasOwnProperty.call(translation, key)) {
      return translation[key]
    }

    // If not found, try nested object approach (for keys like "form.validation.required")
    const keys = key.split('.')
    let nestedTranslation = translation

    for (const k of keys) {
      if (nestedTranslation && typeof nestedTranslation === 'object') {
        nestedTranslation = nestedTranslation[k]
      } else {
        return key // Return original key if path doesn't exist
      }
    }

    return nestedTranslation || key
  }
}

// Export convenience functions
export function setLocale(locale) {
  i18n.setLocale(locale)
}

export function $t(key, params = {}) {
  let translation = i18n.$t(key)

  // Replace parameters in the translation
  Object.keys(params).forEach(param => {
    translation = translation.replace(`{${param}}`, params[param])
  })

  return translation
}



// WEBPACK FOOTER //
// ./src/Assets/utils/i18n.js